"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerReadOnlyBomItemWithStaticMetadataSchema = exports.customerReadOnlyBomItemSchema = void 0;
const zod_1 = require("zod");
const customer_facing_bom_item_1 = require("./customer-facing-bom-item");
const hil_module_resolution_type_1 = require("./hil-module-resolution-type");
const bom_row_datasheet_status_1 = require("./bom-row-datasheet-status");
exports.customerReadOnlyBomItemSchema = zod_1.z.object({
    bomItemId: zod_1.z.string(),
    isDnp: zod_1.z.boolean(),
    resolutionType: hil_module_resolution_type_1.hilModuleResolutionTypeSchema,
    manufacturerPartNumber: zod_1.z.string().nullable(),
    manufacturerId: zod_1.z.string().nullable(),
    manufacturerName: zod_1.z.string().nullable(),
    packageId: zod_1.z.string().nullable(),
    sigmaModelType: zod_1.z.string().nullable(),
    datasheetFileId: zod_1.z.string().nullable(),
    datasheetIsConfidential: zod_1.z.boolean(),
    ...bom_row_datasheet_status_1.bomRowDatasheetStatusFieldsSchema.shape,
});
exports.customerReadOnlyBomItemWithStaticMetadataSchema = exports.customerReadOnlyBomItemSchema.extend({
    staticMetadata: customer_facing_bom_item_1.customerFacingBomItemStaticMetadataSchema,
});
//# sourceMappingURL=customer-read-only-bom-item.js.map